import { TYPES } from './actions';

export const initialState = {
  generatedResumes: {},
  encryptedResumeKey: null,
};

export default function reducer(state = initialState, action = {}) {
  const { payload, type } = action;

  switch (type) {
    case TYPES.GET_GENERATED_RESUME: {
      return {
        ...state,
        generatedResumes: {
          ...state.generatedResumes,
          [payload.resumeID]: {
            isLoading: true,
            data: null,
            error: null,
          },
        },
      };
    }
    case TYPES.GET_GENERATED_RESUME_SUCCESS: {
      return {
        ...state,
        generatedResumes: {
          ...state.generatedResumes,
          [payload.resumeID]: {
            isLoading: false,
            data: payload.pdfContent,
          },
        },
      };
    }
    case TYPES.GET_GENERATED_RESUME_ERROR: {
      return {
        ...state,
        generatedResumes: {
          ...state.generatedResumes,
          [payload.resumeID]: {
            isLoading: false,
            error: payload.error,
          },
        },
      };
    }
    case TYPES.CLEAR_GENERATED_RESUME: {
      return {
        ...state,
        generatedResumes: {
          ...state.generatedResumes,
          [payload.resumeID]: {
            isLoading: false,
            error: null,
            data: null,
          },
        },
      };
    }
    default:
      return state;
  }
}
